import React, { createContext } from 'react';
import { useAircraftFilterState } from './AircraftFilterProvider';
import { ItineraryFragment } from 'generated/graphql';
import { AIRCRAFT_OTHER_KEY } from '../Collector/AircraftCollector';

const AircraftPredicateContext = createContext<
  (itinerary: ItineraryFragment) => boolean
>(() => true);
const createAircraftItineraryPredicate = (aircraftModels) => {
  if (!aircraftModels || aircraftModels.length === 0) return () => true;

  return ({ legs }: ItineraryFragment) =>
    legs?.every(({ segments }) =>
      segments.every(({ sections }) =>
        sections.every(({ vehicleModel }) => {
          const aircraftModel = aircraftModels.filter(
            ({ id }) =>
              id === vehicleModel ||
              (id === AIRCRAFT_OTHER_KEY && !vehicleModel)
          );
          return aircraftModel[0]?.checked;
        })
      )
    ) ?? true;
};

export const AircraftPredicateProvider: React.FC = ({ children }) => {
  const aircraftModels = useAircraftFilterState();
  const aircraftPredicate = createAircraftItineraryPredicate(aircraftModels);

  return (
    <AircraftPredicateContext.Provider value={aircraftPredicate}>
      {children}
    </AircraftPredicateContext.Provider>
  );
};

export const useAircraftPredicate = () =>
  React.useContext(AircraftPredicateContext);
